/** @jsxImportSource @emotion/react */
import { styles } from './VisuallyHidden.styles';

import type { VisuallyHiddenProps } from './VisuallyHidden.types';

export const VisuallyHidden = ({
  children,
  testid,
}: VisuallyHiddenProps): JSX.Element => {
  return (
    <span css={styles} data-testid={testid}>
      {children}
    </span>
  );
};
